import { Search, X } from 'lucide-react'

import { Input } from './ui'

interface IInputSearchProps {
  searchText: string
  setSearchText: (value: string) => void
  placeholder: string
  className?: string
}

const InputSearch: React.FC<IInputSearchProps> = ({
  searchText,
  setSearchText,
  placeholder,
  className,
}) => {
  return (
    <div className={className || 'relative max-w-[400px] w-1/3'}>
      <Input
        type="text"
        placeholder={placeholder}
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
        className="w-full"
        autoComplete="off"
        leadingIcon={<Search size={20} className="text-gray-400 " />}
        trailingIcon={
          searchText ? <X className="w-3.5 h-3.5 cursor-pointer" /> : undefined
        }
        onTrailingIconClick={searchText ? () => setSearchText('') : undefined}
      />
    </div>
  )
}

export default InputSearch
